export function checkMobile (phone) {
  return /^1[0-9]{10}$/.test(phone)
}
export function checkNum (num) {
  // return typeof num === 'number'
  return /^\d{n}$/.test(num)
}
export function money (num) {
  let reg = /^([0-9]+|[0-9]{1,3}(,[0-9]{3})*)(.[0-9]{1,3})?$/
  return reg.test(num)
}
export function bankcard (num) {
  let reg = /^[0-9]{13,19}$/
  return reg.test(num)
}
export function phone (num) {
  let reg = /^(1)\d{10}$/
  return reg.test(num)
}
export function card (num) {
  let reg = /^[0-9a-zA-Z]+$/
  return reg.test(num)
}
export function realName (num) {
  let reg = /^(?:[\u4e00-\u9fa5]+)(?:●[\u4e00-\u9fa5]+)*$|^[a-zA-Z0-9]+\s?[\.·\-()a-zA-Z]*[a-zA-Z0-9]+$/
  return !reg.test(num)
}



// WEBPACK FOOTER //
// ./src/utils/reg.js